import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAppConfigObject } from "appConfig.interfaces";

export const airlinesSearchApi: any = createApi({
  reducerPath: "airlinesSearchApi",
  baseQuery: fetchBaseQuery({
    method: "GET",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Allow-Methods": "POST, GET",
      "Access-Control-Allow-Origin": "*",
    },
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchAirlines: builder.query({
      query: (arg: IFetchAirlinesQuery) => {
        return {
          url: `${arg.config.FLIGHT_SEARCH_API_BASE_URL}/airlines?codes=${arg.query}`,
          method: "GET",
        };
      },
    }),
  }),
});
export const { useFetchAirlinesQuery } = airlinesSearchApi;

interface IFetchAirlinesQuery {
  query: string;
  config: IAppConfigObject;
}
